import React from 'react';
import { CTAButton } from './CTAButton';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-[#060e1a] text-white py-16 md:py-24 px-4 border-t-4 border-blue-600 relative overflow-hidden" data-id="element-58">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-59"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-60">
        <h2 className="text-3xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 mb-8 uppercase leading-tight drop-shadow-sm" data-id="element-61">
          HOY TE LLEVÁS UNA FORMACIÓN COMPLETA PARA EMPEZAR CON CLARIDAD
        </h2>

        <div className="text-lg md:text-xl text-gray-300 space-y-6 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-62">
          <p data-id="element-63">
            No estás comprando información suelta. Estás entrando a un sistema
            que fue pensado para ayudarte a entender el oficio, avanzar paso a
            paso y empezar con una base mucho más firme.
          </p>
          <p className="font-medium text-white" data-id="element-64">
            Si venías postergando porque no sabías por dónde arrancar, esta
            puede ser la oportunidad de ordenar todo y empezar de verdad.
          </p>
        </div>

        <div className="relative group max-w-2xl mx-auto mb-12" data-id="element-65">
          {/* Animated glow behind the box */}
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-blue-400 to-blue-600 rounded-3xl blur opacity-40 group-hover:opacity-70 transition duration-1000 group-hover:duration-200 animate-pulse" data-id="element-66"></div>

          <div className="bg-[#0d1b2a] border border-blue-500/30 rounded-2xl p-8 md:p-12 relative shadow-2xl" data-id="element-67">
            <div className="flex justify-center mb-6" data-id="element-68">
              <div className="w-16 h-16 bg-blue-900/40 rounded-full flex items-center justify-center border border-blue-500/30" data-id="element-69">
                <LockIcon className="w-8 h-8 text-blue-400" data-id="element-70" />
              </div>
            </div>

            <h3 className="text-2xl md:text-3xl font-black text-white mb-4 uppercase" data-id="element-71">
              ACCEDÉ HOY A SISTEMA COMPLETO DE 0 A INSTALADOR DE CÁMARAS
            </h3>

            <div className="inline-block bg-blue-900/30 border border-blue-500/30 px-4 py-2 rounded-lg mb-8" data-id="element-72">
              <p className="text-lg md:text-xl text-blue-300 font-bold flex items-center gap-2" data-id="element-73">
                <ShieldCheckIcon className="w-5 h-5" data-id="element-74" />5 Tomos + 3 Bonos
                Especiales
              </p>
            </div>

            <div className="mb-8" data-id="element-75">
              <p className="text-gray-400 text-sm md:text-base mb-2 uppercase tracking-widest font-bold" data-id="element-76">
                Pago único. Acceso inmediato.
              </p>
              <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6" data-id="element-77">
                <p className="text-2xl md:text-3xl text-gray-500 line-through decoration-red-500/50 font-bold" data-id="element-78">
                  $49.990
                </p>
                <p className="text-6xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-b from-green-400 to-green-600 drop-shadow-lg" data-id="element-79">
                  $29.990
                </p>
              </div>
            </div>

            <CTAButton className="w-full text-xl md:text-2xl py-6 shadow-[0_0_30px_rgba(234,179,8,0.25)]" data-id="element-80">
              [QUIERO ACCEDER AHORA]
            </CTAButton>

            <div className="mt-6 flex items-center justify-center gap-4 text-sm text-gray-400" data-id="element-81">
              <span className="flex items-center gap-1" data-id="element-82">
                <LockIcon className="w-4 h-4" data-id="element-83" /> Pago Seguro
              </span>
              <span className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-84"></span>
              <span data-id="element-85">Acceso Inmediato</span>
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-86">
          <p className="text-xl font-bold text-gray-300 mb-8" data-id="element-87">
            Aprendé a instalar cámaras desde cero, evitá errores de principiante
            y descubrí cómo convertir esta habilidad en un servicio rentable.
          </p>
          <CTAButton className="w-full md:w-auto px-12 py-5 text-lg" data-id="element-88">
            [EMPEZAR AHORA]
          </CTAButton>
        </div>
      </div>
    </section>;
}